const storage = {
    not_configured: '未配置存儲提供程序。',
    missing_parameter: '存儲提供程序缺少參數 {{parameter}}。',
    upload_error: '無法將文件上載到存儲提供程序。',
    download_error: 'Failed to download file from the storage provider.',
};
export default Object.freeze(storage);
